document.addEventListener("turbolinks:load", function () {
  const ruMaskOptions = {
    mask: '+7 (000) 000-00-00',
    lazy: true,

    prepare: function (appended, masked) {
      const unmasked = masked.unmaskedValue;

      // Если поле пустое и ввели 8 — заменяем на 7
      if (unmasked === '' && appended === '8') {
        return '7';
      }

      return appended;
    }
  };

  document.querySelectorAll('.ru_phone').forEach(input => {
    IMask(input, ruMaskOptions);
  });
});